var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-page d-flex __column"},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"d-flex __align-center __justify-center loading-box"},[_c('base-spinner',{attrs:{"size":"72px"}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }